const roles = {
    page_title: 'Papéis',
    title: 'Papéis',
    subtitle: 'Os papéis incluem permissões que determinam o que um usuário pode fazer. RBAC usa papéis para conceder acesso a recursos para ações específicas.',
    create: 'Criar papel',
    role_name: 'Nome do papel',
    role_description: 'Descrição',
    role_name_placeholder: 'Digite o nome do papel',
    role_description_placeholder: 'Digite a descrição do papel',
    assigned_users: 'Usuários atribuídos',
    assign_permissions: 'Atribuir permissões',
    create_role_title: 'Criar papel',
    create_role_description: 'Crie e gerencie papéis para suas aplicações. Os papéis contêm coleções de permissões e podem ser atribuídos a usuários.',
    create_role_button: 'Criar papel',
    role_created: 'O papel {{name}} foi criado com sucesso!',
    search: 'Pesquisar por nome de papel, descrição ou ID',
    placeholder_title: 'Papéis',
    placeholder_description: 'Os papéis são um agrupamento de permissões que podem ser atribuídas a usuários. Certifique-se de adicionar permissões antes de criar papéis.',
};
export default roles;
